import { Action, createReducer, on } from '@ngrx/store';
import { IOfferState, OfferActions } from '.';
import { StateBuilder } from '../../../model/state.builder';

export const initialOfferState: IOfferState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const offerReducerFn = createReducer(
  initialOfferState,
  on(OfferActions.load, (state: IOfferState) => {
    return new StateBuilder<IOfferState>(state).toLoading().build();
  }),
  on(OfferActions.loadSuccess, (state: IOfferState, action) => {
    return {
      ...state,
      ...{
        data: { ...state.data, ...action.data }
      }
    };
  }),
  on(OfferActions.submit, (state: IOfferState) => {
    return new StateBuilder<IOfferState>(state).toLoading().build();
  }),
  on(OfferActions.submitSuccess, (state: IOfferState, action) => {
    return {
      ...state,
      ...{
        data: { ...state.data, ...action.data }
      }
    };
  })
);

export function offerReducer(state: IOfferState | undefined, action: Action) {
  return offerReducerFn(state, action);
}
